import { useEffect, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { Constants } from '../../defines/Constants';
import axios from 'axios';
import Loading from '../Loading';
import './BlocksIcons.css';

const BlocksIcons = () => {
    const [blocksIcons, setBlocksIcons] = useState([]);
    const blocksIconsApi = Constants.api.blocksIcons;
    useEffect(() => {
        const getBlocksIcons = async () => {
            try {
                const results = await axios.get(blocksIconsApi);
                if (results.status === 200) {
                    setBlocksIcons(results.data.block_icon_items);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getBlocksIcons();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const blocksIconsEl = blocksIcons.map((item: any, index: number) =>
        <div key={'index' + index} className="blocks-icons-item">
            <div>
                <IonIcon icon={Constants.uploads + '/blocks_icons/' + item.icon} />
                <span>{item.title}</span>
            </div>
        </div>
    )
    return (
        <div className="blocks-icons-container">
            {blocksIcons.length === 0 ?
                <Loading />
                :
                blocksIconsEl
            }
        </div>
    );
};
export default BlocksIcons;